import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import PDP from '../assets/equipment/3.12-PDP.png';
import TransformerStand from '../assets/equipment/3.13-transformer-stand.png';
import PAC from '../assets/equipment/3.14-PAC.png';
import ServerPanel from '../assets/equipment/3.15-server-panel.png';
import TriggerPanel from '../assets/equipment/3.17-trigger-panel.png';
import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAssemblies = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Electrical Panels</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="PDP" className="mb-3">
								<Tab eventKey="PDP" title="PDP">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>POWER DISTRIBUTION PANEL (PDP)</h2>
											<p>
												There is (1) Power Distribution Panel (<b>PDP</b>) for the SMARTInspect Main Frame and Tail Gate cells. The system <b>PDP</b> receives 480VAC 3-phase 60Hz. power supplied from the plant control bus electrical drop. The <b>PDP</b> also distributes 480 VAC to the Transformer Stand, and 240/120/24 VAC to various panels and components. The <b>PDP</b> has a lockable electrical power disconnect for switching main power ON / OFF. The system’s electrical ECPL lockout/Tagout (LOTO) placard is mounted on the front.
											</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={PDP} alt="Master Key Box" style={{ width: '42vw', margin: '20px' }} />
												<figcaption>Figure 1: Power Distribution Panel</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Transformer Stand" title="Transformer Stand">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>TRANSFORMER STAND</h2>
											<p>On the transformer stand are three (3) transformers used to reduce incoming 480 VAC plant voltage from the PDP to either 120 or 240 VAC for various electrical components.</p>
											<p>Note that each transformer is wired downstream of the main disconnect and have their own rotary disconnect switch located inside the PDP to isolate the circuit when rotated to the OFF position.</p>

											<ul>
												<li>
													<b>236T</b> - Sola 7.5 kVA transformer 480 / 120 VAC – UPS1 Power Supply (SP)
												</li>
												<li>
													<b>246T</b> - Sola 7.5 kVA transformer 480 / 120 VAC – UPS2 Power Supply (SP)
												</li>
												<li>
													<b>316T</b> - 10 kVA 480 / 240 VAC – Servers 1~5 Power (SP)
												</li>
											</ul>
										</div>

										<div class="right-side">
											<figure>
												<img src={TransformerStand} alt="Master Key Box" style={{ width: '27vw', margin: '20px' }} />
												<figcaption>Figure 1: Transformer Stand</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								{/* <Tab eventKey="PAC" title="PAC">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '45vw' }}>
											<h2>PROGRAMMABLE AUTOMATION CONTROLLER (PLC)</h2>
											<p>
												The Programmable Automation Controller panel houses the Allen-Bradley 1756 Process Logic Controller (<b>PLC</b>), I/O and Ethernet modules, as well as Safety modules.
											</p>
											<p>There is a programming port with Ethernet, USB and 120 VAC receptacle located on the left side of the panel.</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={PAC} alt="Master Key Box" style={{ width: '20vw', margin: '20px' }} />
												<figcaption>
													Figure 1: Programmable Automation Controller (<b>PLC</b>)
												</figcaption>
											</figure>
										</div>
									</div>
								</Tab> */}

								<Tab eventKey="Server Panel" title="Server Panel">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '45vw' }}>
											<h2>SERVER PANEL</h2>
											<p>
												The server rack, where the servers are stored, include the KVM switch (which swaps which server is currently visible on the monitor), server power supplies, switches, <b>PLC</b> connections, and the air conditioning unit itself.
											</p>
											<h5>GPU</h5>
											<p>Each GPU server runs two services locally – the SPU service and Image-Capture service for that server. Each Image-Capture service connects the server to a subset of cameras in the inspection cells and handles the capturing of images for those cameras. Those images are then forwarded to the GPU service, which processes the images, detects potential defects, and flags them as regions of interest to be checked by the clustering service.</p>
											<h5>Networked-Attached-Storage (NAS)</h5>
											<p>
												The NAS server is the storage location for common files, folders, scans, and configurations across every other server, it is a centralized “hub” of information storage that all other servers can access. It can be considered the “Main” server; the corresponding <b>HMI</b> has the largest availability of informatic and diagnostic plugins. The NAS server communicates with the <b>PLC</b> to get information about incoming vehicles. It also communicates with the trigger board to read the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions. It receives regions of interest from the GPU service and runs images of them through a machine learning model trained to detect and classify defects. If a defect is detected, it will determine where on the vehicle the defect is so that it can be displayed on the overhead display. It then generates the images for the display once all of the regions of interest are checked.
											</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={ServerPanel} alt="Master Key Box" style={{ width: '38vw', margin: '20px' }} />
												<figcaption>Figure 1: Server Rack (Left: Closed, Right: Open)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Trigger Panels" title="Trigger Panels">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '45vw' }}>
											<h2>TRIGGER PANELS (TP1 & TP2)</h2>
											<p>There are two (2) Trigger Panels (TP1 and TP2) located on either side of the conveyor near the exit of the Main Frame inspection cell. A third trigger Panel (TP3) located on the left side of the Tail Gate inspection cell enclosure near the entrance. They contain the power supply/circuit boards components and trigger board to read the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions.</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={TriggerPanel} alt="Master Key Box" style={{ width: '25vw', margin: '20px' }} />
												<figcaption>Figure 1: Trigger Panel (TP3 shown, TP1 and TP2 similar)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
